module.exports = __webpack_public_path__ + "static/img/GD.08e34161.svg";